import { API_KEYS_API, fetchWithAccount } from '@/api/client'
import type {
  ApiKeyGenerationResponse,
  ApiKeyResponse,
  CreateApiKeyRequest,
  RevokeApiKeyRequest,
  RotateApiKeyRequest,
  RotateApiKeyResponse,
  UpdateApiKeyRequest,
} from '../types/apiKey.types'

export async function fetchAvailableScopes(): Promise<string[]> {
  const res = await fetch(`${API_KEYS_API}/scopes`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      'Content-Type': 'application/json',
    },
  })
  if (!res.ok) throw new Error(`Failed to fetch scopes: ${res.status}`)
  return res.json()
}

export async function listApiKeys(accountId: string, enabledOnly?: boolean): Promise<ApiKeyResponse[]> {
  const url = enabledOnly ? `${API_KEYS_API}?enabledOnly=true` : API_KEYS_API
  return fetchWithAccount<ApiKeyResponse[]>(url, accountId)
}

export async function getApiKey(accountId: string, keyId: string): Promise<ApiKeyResponse> {
  return fetchWithAccount<ApiKeyResponse>(`${API_KEYS_API}/${keyId}`, accountId)
}

export async function createApiKey(
  accountId: string,
  data: CreateApiKeyRequest,
): Promise<ApiKeyGenerationResponse> {
  return fetchWithAccount<ApiKeyGenerationResponse>(API_KEYS_API, accountId, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function updateApiKey(
  accountId: string,
  keyId: string,
  data: UpdateApiKeyRequest,
): Promise<ApiKeyResponse> {
  return fetchWithAccount<ApiKeyResponse>(`${API_KEYS_API}/${keyId}`, accountId, {
    method: 'PATCH',
    body: JSON.stringify(data),
  })
}

export async function rotateApiKey(
  accountId: string,
  keyId: string,
  data: RotateApiKeyRequest,
): Promise<RotateApiKeyResponse> {
  return fetchWithAccount<RotateApiKeyResponse>(`${API_KEYS_API}/${keyId}/rotate`, accountId, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function revokeApiKey(
  accountId: string,
  keyId: string,
  data: RevokeApiKeyRequest,
): Promise<void> {
  return fetchWithAccount<void>(`${API_KEYS_API}/${keyId}/revoke`, accountId, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function enableApiKey(accountId: string, keyId: string): Promise<ApiKeyResponse> {
  return fetchWithAccount<ApiKeyResponse>(`${API_KEYS_API}/${keyId}/enable`, accountId, {
    method: 'POST',
  })
}

export async function disableApiKey(accountId: string, keyId: string): Promise<ApiKeyResponse> {
  return fetchWithAccount<ApiKeyResponse>(`${API_KEYS_API}/${keyId}/disable`, accountId, {
    method: 'POST',
  })
}

export async function deleteApiKey(accountId: string, keyId: string): Promise<void> {
  return fetchWithAccount<void>(`${API_KEYS_API}/${keyId}`, accountId, {
    method: 'DELETE',
  })
}
